import {
    openInGoogleDocs,
    openInGoogleSheets,
    openInGoogleSlides,
} from './getOpenInGoogleButton.locstring.json';
import loc from 'owa-localize';
import logSxSCommandBarDatapoint from './logSxSCommandBarDatapoint';
import { AttachmentPreviewMethod } from 'owa-attachment-data';
import { lazyGetAttachment } from 'owa-attachment-model-store';
import { ControlIcons } from 'owa-control-icons';
import { FilterableMenuItem, FilterableMenuItemArgs } from 'owa-filterable-menu';
import { getOrCreateSxSStoreData, SxSStoreData } from 'owa-sxs-store';

export default function getOpenInGoogleButton(sxsId: string) {
    const sxsStore = getOrCreateSxSStoreData(sxsId);
    const buttonLabel = getButtonLabel(sxsStore);
    return new FilterableMenuItem({
        [FilterableMenuItemArgs.name]: buttonLabel,
        [FilterableMenuItemArgs.icon]: ControlIcons.OpenInNewWindow,
        [FilterableMenuItemArgs.onClick]: async () => {
            logSxSCommandBarDatapoint('SxSOpenInGoogle', sxsId);
            window.open(sxsStore.viewState.previewPane.downloadUrl);
        },
        [FilterableMenuItemArgs.shouldShow]: () => {
            return (
                sxsStore.viewState.previewPane &&
                !!sxsStore.viewState.previewPane.downloadUrl &&
                sxsStore.extendedViewState.previewMode === AttachmentPreviewMethod.GoogleDoc
            );
        },
    });
}

function getButtonLabel(sxsStore: SxSStoreData) {
    if (sxsStore.extendedViewState.previewMode !== AttachmentPreviewMethod.GoogleDoc) {
        return null;
    }

    const getAttachment = lazyGetAttachment.tryImportForRender();
    const attachmentModel = getAttachment(sxsStore.extendedViewState.attachmentId);

    const contentType = attachmentModel.model.ContentType;
    switch (contentType) {
        case 'application/vnd.google-apps.document':
            return loc(openInGoogleDocs);
        case 'application/vnd.google-apps.spreadsheet':
            return loc(openInGoogleSheets);
        case 'application/vnd.google-apps.presentation':
            return loc(openInGoogleSlides);
        default:
            throw new Error('Unexpected value of Google contentType');
    }
}
